import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation NameBlogPostBuilderDraft($projectId: ID!, $draftId: ID!, $name: String!) {
    nameBlogPostBuilderDraft(projectId: $projectId, draftId: $draftId, name: $name) {
      id
    }
  }
`;

interface Params {
  projectId: ID;
  draftId: ID;
  name: string;
}

export const nameBlogPostBuilderDraft = async ({ projectId, draftId, name }: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, draftId, name },
  });

  return getSingleProp<Entity>(result.data);
};
